import React, { HTMLAttributes } from 'react';
import { MdCall, MdCallReceived } from 'react-icons/md';
import * as styles from '../../styles/icons/callIcon.module.scss';
import CombinedIconTopRight from './CombinedIconTopRight';

const InboundCall: React.FC<HTMLAttributes<HTMLSpanElement>> = (props) => (
  <CombinedIconTopRight
    MainIcon={MdCall}
    SmallIcon={MdCallReceived}
    colorSmall='green'
    className={styles.nudge_2}
    {...props}
  />
);

export default InboundCall;
